import { useState } from "react";
import { useTranslation } from "react-i18next";

import urls from "../../api/urls";
import { getUserFromLocalStorage } from "../../utils/localStorage";
import { cn } from "../../utils/styling";
import { Icon } from "../Icon";

export const Asset3DViewer = ({ buildingId }: { buildingId?: number }) => {
  const { t } = useTranslation();

  let user = getUserFromLocalStorage();
  const userToken = user.access_token;

  const [isMinified, setIsMinified] = useState(true);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  const sendIsMinifiedStatusToIframe = (isMinifiedNewState: boolean, onConfirm?: () => void) => {
    const iframe = document.getElementById("3dviewer-frame") as HTMLIFrameElement;
    iframe?.contentWindow?.postMessage({ params: { is_minified: isMinifiedNewState }, type: "updateParams" }, "*");

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "paramsUpdated") {
        onConfirm?.();
        window.removeEventListener("message", handleMessage);
      }
    };
    window.addEventListener("message", handleMessage);
  };

  const handleIframeLoad = () => {
    setTimeout(() => {
      sendIsMinifiedStatusToIframe(true);
      setIsIframeLoaded(true);
    }, 500);
  };

  return (
    <div
      className={cn(
        "relative h-[40rem]",
        !isMinified && "fixed inset-0 z-[10000] flex h-screen items-center justify-center "
      )}
    >
      <Icon
        className={cn("absolute  -top-0 right-0", !isMinified && "fixed right-8 top-10 z-[200000] ")}
        iconName={!isMinified ? "FullscreenExit" : "Fullscreen"}
        onClick={() => {
          if (isMinified) {
            setIsMinified(!isMinified);
            sendIsMinifiedStatusToIframe(!isMinified);
          } else {
            sendIsMinifiedStatusToIframe(!isMinified, () => setIsMinified(!isMinified));
          }
        }}
        size="lg"
      />
      {!isIframeLoaded && (
        <div className="flex h-full w-full items-center justify-center ">
          <span className="font-ds-headline-xl -translate-y-12 animate-pulse text-lds-link-primary duration-500">
            {t("BuildingPassportSharedLayout.threeDViewer")}
          </span>
        </div>
      )}
      <iframe
        className={cn("h-full w-full border-none", !isIframeLoaded && "opacity-0")}
        id="3dviewer-frame"
        onLoad={handleIframeLoad}
        src={urls.redirects.threeDViewer(buildingId, userToken)}
      />
    </div>
  );
};
